// useForceUpdate is the easiest way to force a component to re-render. This is
// useful when you call out to a stateful store that doesn't automatically
// notify React that it needs to update.

import { useCallback, useState } from 'react';

export default function useForceUpdate(): () => void {
	const [, setNonce] = useState<object>({});
	return useCallback((): void => setNonce({}), []);
}
